import { Component, OnInit, Input } from '@angular/core';
import { CertificationTypes } from 'src/app/model/enums/certificationTypes';
import { environment } from 'src/environments/environment';

@Component({
    selector: 'app-certificate-mini-display',
    templateUrl: './certificate-mini-display.component.html',
    styleUrls: ['./certificate-mini-display.component.css'],
    standalone: false
})
export class CertificateMiniDisplayComponent implements OnInit {
    @Input()
    certificateType: string; //CertificationTypes ist im Backend als Enum, im frontend wird das Enum-Objekt als String geladen
    @Input()
    certCount: number;
    certificationImageUrl: string;
    certificationTooltip: string;
    certificationCountTooltip: string;
    @Input() full?: boolean = false;
    ngOnInit(): void {
        switch (this.certificateType) {
            case CertificationTypes.ATTRIBUTE_CERT:
                this.certificationImageUrl =
                    environment.certificationAttributeIcon;
                this.certificationTooltip = 'Zertifikat für Merkmale';
                this.certificationCountTooltip = 'Anzahl der Zertifikate';
                break;
            case CertificationTypes.PTG_CERT:
                this.certificationImageUrl = environment.certificationPtgIcon;
                this.certificationTooltip = 'Zertifikat für Produkttyp';
                this.certificationCountTooltip = 'Anzahl der Zertifikate';
                break;
            case CertificationTypes.TOOLCHAIN_CERT:
                this.certificationImageUrl = environment.certificationToolchain;
                this.certificationTooltip = 'Zertifikat für Toolchains';
                this.certificationCountTooltip = 'Anzahl der Zertifikate';
                break;
            case CertificationTypes.ATTRIBUTE_MANDATORY_CERT:
                this.certificationImageUrl = environment.certificationPtgIcon;
                this.certificationTooltip =
                    'Zertifikat für verpflichtende Merkmale';
                this.certificationCountTooltip = 'Anzahl der Produkttypen';

                break;
            case CertificationTypes.PARTNER_CERT:
                this.certificationImageUrl =
                    environment.partnerCert;
                this.certificationTooltip =
                    'Zertifikat für BIMSWARM Partnership';
                this.certificationCountTooltip = 'BIMSWARM Partner';
                break;    
            case "BIMSWARM_CERT":
                    this.certificationImageUrl = environment.certificationPtgIcon;
                    this.certificationTooltip =
                        'Zertifikat für verpflichtende Merkmale und Produkttyp';
                    this.certificationCountTooltip = 'BIMSWARM Partner';
                    break;        
            default:
                //throw Error("invalid CertificationType");
                break;
        }
    }

    constructor() {}
}
